import React from 'react';
import '../style.scss';

const CustomAlert = ({ message, onClose }) => {
  return (
    <div className={`custom-alert-overlay show`}>
      <div className="custom-alert-box">
        <p>{message}</p>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default CustomAlert;